// src/data/zencode/zenakku.js
const ZenAkku = {
  slug: "zenakku",
  title: "ZenAkku",
  description: "Ein Lade-Indikator mit Haltung – für den Mac.",
  tags: ["macOS", "SwiftBar", "Achtsamkeit"],
  icon: "battery",
  cover: "/images/projects/zenakku-min.png",
  cover2: "/images/projects/zenAkku_app.png",
  content: `
### Was ist ZenAkku?

ZenAkku zeigt dir:

- Deinen Akkustand 
- Dein echten RAM
- Deine freie Kapazität auf deiner SSD

aber auf eine Weise, die dich nicht stresst. 

Auf Zen Weisheit:

Reduziert. Klar. Echt.

### Warum es entstanden ist

Manchmal reicht ein Kreis. Ein stilles Signal. ZenAkku verbindet Technik mit Haltung.

👉 [Zur App](/zencode/zenakku)
  `,
};

export default ZenAkku;
